import React, { PureComponent } from 'react';
import LocaleContext from './LocaleContext';

export default WrappedComponent => {
  return class extends PureComponent {
    render() {
      return (
        <LocaleContext.Consumer>
          {context => <WrappedComponent {...this.props} locale={context} />}
        </LocaleContext.Consumer>
      );
    }
  };
};
